<template>
  <div>
    <h4 class="prod-type-text">
      <strong> {{ item.ITEM_NAME }} </strong>
    </h4>
    <b-row class="p-1 d-flex flex-row flex-nowrap">
      <div class="border rounded-left py-1 flex-grow-1">
        <b-row>
            <b-form-group 
              v-for="(option, index) in options" :key="index"
              class="mx-1"
            >
              <b-form-select
                @change="onSelectOption($event, index + 1)"
                v-if="option && option.child && option.child.length > 0"
              >
                <b-form-select-option :value="null" disabled>
                  -- Select option --
                </b-form-select-option>
                <b-form-select-option
                  v-for="
                    (childOption, indexOption)
                      in 
                        option.child
                  "
                  :key="indexOption + childOption.PARENT"
                  :value="childOption"
                >
                  {{ childOption.ITEM_NAME }}
                  {{
                    childOption.ITEM_PAY_TYPE ? '/ ' + childOption.ITEM_PAY_TYPE : ''
                  }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group 
              class="mx-1"
            >
              <b-form-select
                v-if="(availableTypeValue.length > 0 && isItInterpolation) && !canDoSLWDM"
                v-model="selectedType"
              >
                <b-form-select-option :value="null" disabled>
                  -- Select option --
                </b-form-select-option>
                <b-form-select-option
                  v-for="type in availableTypeValue"
                  :key="type"
                  :value="type"
                >
                  {{ type  }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group 
              class="mx-1"
            >
              <b-form-input
                v-if="(availableTypeValue.length > 0 && isItInterpolation) && !canDoSLWDM"
                v-model="interpolationValue"
                type="number"
              />
            </b-form-group>
            <div
              v-if="isItQos && isOptionQosLevel "
              class="d-flex"
            >
              <b-form-group 
                class="mx-1"
              >
                <b-form-select
                  v-model="selectedTypeQoS"
                >
                  <b-form-select-option :value="null" disabled>
                    -- Select option --
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="type in qosTypes"
                    :key="type"
                    :value="type"
                  >
                    {{ type  }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group 
                class="mx-1"
              >
                <b-form-select
                  v-model="selectedValueQoS"
                >
                  <b-form-select-option :value="null" disabled>
                    -- Select option --
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="value in qosValues"
                    :key="value"
                    :value="value"
                  >
                    {{ value  }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div
              v-if="isItQos && isOptionQosLevel"
              class="d-flex"
            >
              <b-form-group 
                class="mx-1"
                description="Best Effort"
              >
                <b-form-input
                  v-model.number="bestEffortValue"
                  type="number"
                  placeholder="Best Effort"
                  @input="changeQoS('bestEffortValue', $event)"
                />
              </b-form-group>
              <b-form-group 
                class="mx-1"
                description="Critical"
              >
                <b-form-input
                  v-model.number="criticalValue"
                  type="number"
                  placeholder="Critical"
                  @input="changeQoS('criticalValue', $event)"
                />
              </b-form-group>
              <b-form-group 
                class="mx-1"
                description="Interactive"
              >
                <b-form-input
                  v-model.number="interactiveValue"
                  type="number"
                  placeholder="Interactive"
                  @input="changeQoS('interactiveValue', $event)"
                />
              </b-form-group>
            </div>
            <small v-if="isItQos && isOptionQosLevel && !canAddItem" class="mx-1 text-danger">
            Jumlah presentase pada perhitungan (Best Effort, Critical dan Interactive) tidak boleh kurang atau lebih dari 100%
            </small>
            <b-form-group 
              v-if="alreadyEnd && canDoSLWDM && isItInterpolation"
              class="mx-1"
            >
              <b-form-select
                v-model="selectedInterpolationSLWDM"
              >
                <b-form-select-option :value="null" disabled>
                  -- Select option --
                </b-form-select-option>
                <b-form-select-option
                  v-for="
                    (data, index)
                      in 
                        this.lastList.filter(x => x.ITEM_NAME.toLowerCase() !== 'interpolasi')
                  "
                  :key="index"
                  :value="data"
                >
                  {{ data.ITEM_NAME }}
                  {{
                    data.ITEM_PAY_TYPE ? '/ ' + data.ITEM_PAY_TYPE : ''
                  }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group 
              v-if="alreadyEnd && canDoSLWDM && isItInterpolation"
              class="mx-1"
              description="GB"
            >
              <b-form-input
                v-model.number="slwdmGB"
                type="number"
                placeholder="GB"
              />
            </b-form-group>
        </b-row>
      </div>

      <div class="border rounded-right border-left-0 d-flex align-items-center">
        <div class="">
          <h3 class="text-center my-1">
            Rp.
            {{
              new Intl.NumberFormat('id-ID').format(
                finalPrice * quantity
              )
            }}
          </h3>
          <b-input-group class="mb-1" style="width: 100%">
            <b-form-spinbutton
              v-model="quantity"
              min="1"
            />
          </b-input-group>
        </div>
      </div>
    </b-row>
    <div class="d-flex justify-content-end mt-1">
      <b-button
        v-tracker="'button:add-item'"
        :disabled="!canAddItem"
        variant="primary"
        @click="addItem()"
      >
        Add Item
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BFormSpinbutton,
  BSpinner,
  BCard,
  BCardText,
  BCol,
  BRow,
  BForm,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormGroup,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BLink,
} from 'bootstrap-vue'
import { computed } from 'vue';
import { data } from 'vue-echarts';

export default {
  props: {
    root: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    qos: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      options: [],
      values: [],
      quantity: 1,
      interpolationValue: 0,
      selectedType: '',
      interactiveValue: 0,
      bestEffortValue: 0,
      criticalValue: 0,
      selectedTypeQoS: '',
      qosValue: 0,
      selectedValueQoS: 0,
      constant: [
        { v: 10, k: 1 },
        { v: 20, k: 1.9 },
        { v: 30, k: 2.7 },
        { v: 40, k: 3.5 },
        { v: 50, k: 4.2 },
        { v: 60, k: 4.8 },
        { v: 70, k: 5.4 },
        { v: 80, k: 5.9 },
        { v: 90, k: 6.4 },
        { v: 100, k: 6.8 }
      ],
      slwdmGB: 0,
      selectedInterpolationSLWDM: {}
    }
  },
  components: {
    BCardText,
    BSpinner,
    BFormSpinbutton,
    BCol,
    BCard,
    BRow,
    BForm,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormGroup,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BLink,
  },
  mounted() {
    if (this.isItQos) {
      this.handleOptionsCanQos(this.item)
    }
    if (this.root === 'SL WDM' && this.item.ITEM_NAME === 'PAKET') {
      const item = this.getSLWDMWithInterpolation(this.item)
      console.log('AHAY', item)
      // const item = this.item
      // console.log('oyoyoy', item)
      this.$set(this, 'options', [{
          ...item,
        index: 0
      }])
    } else {
      this.$set(this, 'options', [{
          ...this.item,
        index: 0
      }])
    }
    console.log('ini options', this)
  },
  computed: {
    selectedProduct() {
      const rootName = this.root
      const options = [...this.options]
      const lengthOptions = options.length
      const base = {
        kode : null,
        root : rootName,
        prod_id : this.$route.query?.index ?? 1,
        name : '',
        item_name: null,
        qty : this.quantity,
        price : this.finalPrice,
        type : null
      }
      
      return options.reduce((pre, curr, currIndex) => {
        const separator = currIndex !== 0 ?  ' - ' : ''
        pre.name = pre.name + (separator + curr.ITEM_NAME)
        const currIsEnd = currIndex === (lengthOptions - 1)
        if (currIsEnd) {
          pre.type = !this.isItInterpolation ? curr.ITEM_PAY_TYPE : this.selectedType
          pre.item_name = curr.ITEM_NAME
          pre.kode = curr.PARENT
          pre.name = pre.name + '/' + curr.ITEM_PAY_TYPE
        }
        if (currIsEnd && currIndex === 0) {
          pre.name = pre.ITEM_NAME + '/' + curr.ITEM_PAY_TYPE
        }
        return pre
      }, base)
    },
    alreadyEnd() {
      const options = this?.options ?? []
      if (options.length === 0) {
        return false
      }
      else if (options.length > 0 && options[options.length - 1].child.length === 0) {
        return true
      } else {
        return false
      }
    },
    lastList() {
      if (!this.alreadyEnd) {
        return []
      } else if (this.options.length === 2) {
        return []
      }
      return this.options[this.options.length - 2].child
    },
    availableTypeValue() {
      const lastList = this.lastList
      const option = [...new Set(lastList.map(item => item.ITEM_NAME.split(' ')[1]))]
      return option.filter(item => item != null)
    },
    availableValue() {
      const lastList = this.lastList.filter(item => item.ITEM_NAME.split(' ')[1] === this.selectedType)
      const option = [...new Set(lastList.map(item => parseInt(item.ITEM_NAME.split(' ')[0])))]
      const optionOrderAsc = option.sort((a, b) => a - b)
      return optionOrderAsc.filter(item => !Number.isNaN(item))
    },
    lastSelectedItem() {
      return this.options[this.options.length - 1]
    },
    findTwoClosest() {
      const givenList = this.availableValue
      const goal = this.interpolationValue
      const result = givenList.reduce((pre, curr) => {
        if (goal - curr > -1 &&  goal - curr < goal - pre.min ) {
          pre.min = curr
        }
        if (curr - goal > -1 &&  curr - goal < pre.max - goal ) {
          pre.max = curr
        }
        return pre
      }, { min: -Infinity, max: Infinity })

      return result
    },
    isItInterpolation() {
      return this.lastSelectedItem?.ITEM_NAME?.toLowerCase()?.includes('interpolasi') ?? false
    },
    interpolateCalc(){
      const { min, max } = this.findTwoClosest
      if (Number.isInteger(min) && Number.isInteger(max) && min === max) {
        return this.iterpolationUsingCurrentOption
      }
      const bottom = this.lastList.find(list => {
        const [value, type] = list.ITEM_NAME.split(' ')
        return parseInt(value) === min && type === this.selectedType
      })
      const bottomValue = bottom?.ITEM_NAME.split(' ')[0] ?? 0
      const bottomPrice = bottom?.LIST_PRICE ?? 0
      const top = this.lastList.find(list => {
        const [value, type] = list.ITEM_NAME.split(' ')
        return parseInt(value) === max && type === this.selectedType
      })
      const topValue = top?.ITEM_NAME.split(' ')[0] ?? 0
      const topPrice = top?.LIST_PRICE ?? 0

      const x = parseFloat(this.interpolationValue) - parseFloat(bottomValue);
      const y = parseFloat(topValue) - parseFloat(bottomValue)
      const tarif = parseFloat(bottomPrice) + ((x/y) * (parseFloat(topPrice) - parseFloat(bottomPrice)) )
      return tarif
    },
    iterpolationUsingCurrentOption() {
      const { min, max } = this.findTwoClosest
      if (Number.isInteger(min) && Number.isInteger(max) && min === max) {
        const item = this.lastList.find(list => {
          const [value, type] = list.ITEM_NAME.split(' ')
          return parseInt(value) === min && type === this.selectedType
        })
        return parseFloat(item?.LIST_PRICE ?? 0)
      }
      else {
        0
      }
    },
    isOptionQosLevel() {
      return this.options.length === 3 && this.options[2] && this.options[2].child.length === 0
    },
    isItQos() {
      return this.qos.length > 0
    },
    listQoSAccordingToArea() {
      if (this.isItQos) {
        const selectedItem = this.options[1]?.ITEM_NAME ?? ''
        return this.qos.filter(item => {
          return item.group.toLowerCase() === selectedItem.toLowerCase()
        })
      } else {
        return []
      }
    },
    qosTypes() {
      const types = this.listQoSAccordingToArea.map(item => item.type.toLowerCase())
      return [...new Set(types.filter(x => x !== null))]
    },
    qosValues() {
      const types = this.listQoSAccordingToArea.filter(item => item.type.toLowerCase() === this.selectedTypeQoS).map(item => item.value)
      return [...new Set(types.filter(x => x !== null))]
    },
    qosPrice() {
      if (this.isItQos && this.isOptionQosLevel && this.selectedTypeQoS && this.selectedValueQoS) {
        const critical = this.listQoSAccordingToArea.find(x => x.value === this.selectedValueQoS && x.type.toLowerCase() === this.selectedTypeQoS && x.level === 'critical') ?? { price: 0 }
        const bestEffort = this.listQoSAccordingToArea.find(x => x.value === this.selectedValueQoS && x.type.toLowerCase() === this.selectedTypeQoS && x.level === 'best effort') ?? { price: 0 }
        const interactive = this.listQoSAccordingToArea.find(x => x.value === this.selectedValueQoS && x.type.toLowerCase() === this.selectedTypeQoS && x.level === 'interactive') ?? { price: 0 }
        return ((critical.price * this.criticalValue) / 100) + ((bestEffort.price * this.bestEffortValue) / 100) + ((interactive.price * this.interactiveValue) / 100)
      } else {
        return 0
      }
    },
    finalPrice() {
      if (this.isItInterpolation && !this.canDoSLWDM) {
        return this.interpolateCalc
      } else if (this.canDoSLWDM && this.isItInterpolation) {
        return this.slwdmPrice
      } else if (this.isItQos && this.isOptionQosLevel) {
        return this.qosPrice
      } else {
        return parseInt(this.options[this.options.length - 1]?.LIST_PRICE ?? 0, 10)
      }
    },
    canDoSLWDM() {
      const cartTitleValid = (this.options[0]?.ITEM_NAME ?? '') === 'PAKET'
      return this.root === 'SL WDM' && cartTitleValid
    },
    findTwoClosestSLWDM() {
      const givenList = this.constant.map(x => x.v)
      const goal = this.slwdmGB
      const result = givenList.reduce((pre, curr) => {
        if (goal - curr > -1 &&  goal - curr < goal - pre.min ) {
          pre.min = curr
        }
        if (curr - goal > -1 &&  curr - goal < pre.max - goal ) {
          pre.max = curr
        }
        return pre
      }, { min: -Infinity, max: Infinity })

      return result
    },
    slwdmPrice() {
      const basePrice = (this.lastList.find(item => {
        return item === this.selectedInterpolationSLWDM
      }) ?? {})?.LIST_PRICE ?? 0
      const { min, max } = this.findTwoClosestSLWDM
      const constant = this.constant
      if (Number.isInteger(min) && Number.isInteger(max) && min === max) {
        return basePrice * (constant.find(item => item.v === min)?.k ?? 0)
      }
      const bottom = constant.find(item => {
        return item.v === min
      })
      const bottomValue = bottom?.v ?? 0
      const bottomPrice = basePrice * (bottom?.k ?? 0)
      const top = constant.find(item => {
        return item.v === max
      })
      const topValue = top?.v ?? 0
      const topPrice = basePrice * (top?.k ?? 0)

      console.log(this.slwdmGB);
      console.log(bottomValue);
      console.log(topValue);

      const x = parseFloat(this.slwdmGB) - parseFloat(bottomValue);
      const y = parseFloat(topValue) - parseFloat(bottomValue)
      const tarif = parseFloat(bottomPrice) + ((x/y) * (parseFloat(topPrice) - parseFloat(bottomPrice)) )
      console.log(tarif);
      return tarif
    },
    canAddItem() {
      if (this.isItQos && this.isOptionQosLevel) {
        return parseInt(this.bestEffortValue) + parseInt(this.criticalValue) + parseInt(this.interactiveValue) === 100
      } else {
        return true
      }
    }
  },
  methods: {
    onSelectOption(selectedOption, index) {
      const lastOptions = this.options[this.options.length - 1].child
      const lastItemOnOptions = lastOptions[lastOptions.length - 1]
      this.$set(this, 'options', [...this.options.slice(0, index), {
        ...selectedOption,
        index
      }])
    },
    addItem() {
      this.$emit('addItem', this.selectedProduct)
    },
    handleOptionsCanQos(item) {
      const newItem = { ...item }
      const child = [...newItem.child]
      const newChild = child.map(item => {
        if (item.child.length > 0) {
          item.child = item.child.reduce((pre, curr, currentIndex) => {
            pre.push(curr)
            if (currentIndex === item.child.length - 1) {
              const [title, number] = curr.ITEM_NAME.split(' ')
              pre.push({...curr, ITEM_NAME: 'PAKET CUSTOM', child: []})
              // pre.push({...curr, ITEM_NAME: 'PAKET CUSTOM'})
            }
            return pre
          }, [])
        }
        return item
      })
      this.$set(newItem, 'child', [...newChild])
      return newItem
    },
    changeQoS(vModel, event) {
      const listModel = ['interactiveValue', 'bestEffortValue', 'criticalValue']
      const sum = listModel.reduce((pre, curr) => {
        let value = pre
        if (curr !== vModel) {
          value += this[curr]
        }
        return value
      }, 0)
      const maxValue = 100 - sum
      if (event > maxValue) {
        const vm = this
        setTimeout(() => {
          vm[vModel] = maxValue
        }, 300)
      }
      console.log(sum)
    },
    getSLWDMWithInterpolation(item) {
      const newItem = { ...item }
      newItem.child = this.checkAndInjectInterpolation(newItem.child)
      return newItem
    },
    checkAndInjectInterpolation(item) {
      return item.reduce((pre, curr, currentIndex) => {
        const itemLength = item.length
        pre.item.push(curr)
        if (curr.child.length > 0) {
          pre.oneOfListHaveAChild = true
          curr.child = [...this.checkAndInjectInterpolation(curr.child)]
        } else if ((currentIndex + 1) === itemLength && pre.oneOfListHaveAChild === false) {
          pre.item.push({...curr, ITEM_NAME: 'INTERPOLASI', child: []})
        }
        return pre
      }, { item: [], oneOfListHaveAChild: false }).item
    }
  }
}
</script>

<style>
/* Small devices (phones, 767px and below) */
@media (max-width: 767px) {
  .prod-type-text {
    font-size: 1.25rem;
  }
}
</style>